import styled from 'styled-components'

export const DocumentationTableWrapper = styled.div`
  position: relative;
  padding: 30px 0 0 0;
  background: ${props => props.theme.colors.white};
  button {
    margin-left: 40px;
  }

  & > div:nth-child(1) {
    position: absolute;
    top: 30px;
    left: 50px;
  }

  & > div:nth-child(2) {
    .filters-wrapper {
      margin-top: 0;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Settings/Documentation/DocumentationTableWrapper/index.js